/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {PermissionId} from "../../models/users/Permission";
import {hasPermissions, isLoggedIn} from "../../services/guards/permission-guard";

export const enterpriseRoutes = [
  {
    path: "enterprise",
    canActivateChild: [isLoggedIn, hasPermissions(PermissionId.SeeEnterpriseFeatures)],
    children: [
      // Forecast
      {
        path: "forecast",
        children: [
          {
            path: "",
            loadComponent: () => import("./forecast/enterprise-forecast").then(m => m.EnterpriseForecast),
          },
          {
            path: "summary",
            canActivate: [hasPermissions(PermissionId.SeeForecastSummary)],
            loadComponent: () => import("./forecast/summary/enterprise-forecast-summary").then(m => m.EnterpriseForecastSummary),
          },
        ],
      },

      // Year to Date (YtD)
      {
        path: "year-to-date",
        children: [
          {
            path: "",
            loadComponent: () => import("./year-to-date/enterprise-year-to-date").then(m => m.EnterpriseYearToDate),
          },
          {
            path: "report-total",
            canActivate: [hasPermissions(PermissionId.SeeYearToDateSummary)],
            loadComponent: () => import("./year-to-date/report-total/enterprise-year-to-date-report-total").then(m => m.EnterpriseYearToDateReportTotal),
          },
        ],
      },

      // Planned / Plannable
      {
        path: "planned",
        loadComponent: () => import("./planned/enterprise-planned").then(m => m.EnterprisePlanned),
      },
    ],
  },
] as const satisfies Routes;
